<script>
import ModalConfirmacao from "../shared/ModalConfirmacao.vue";

export default {
  name: "ContainerImportacaoAzureAD",
  components: {
    ModalConfirmacao
  },
  data() {
    return {
      loading: false,
      aberto: false
    }
  },
  methods: {
    importAzureAd() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$util.atualizar(this, {
        service: 'azure_integracao',
        func: 'importar_usuarios_azure',
        callback: () => {
          this.$emit('refresh');
        },
        callback_error: error => {
          this.$toast.add({
            severity: "error",
            summary: "Falha ao importar usuários Azure AD",
            detail: this.mensagemErro(error),
            life: 4000,
          });
        },
        final: () => {
          this.loading = false;
          this.aberto = false;
        }
      });
    },
    mensagemErro(error) {
      return (error && error.data && error.data.mensagem) || 'Falha ao importar usuários Azure AD';
    },
  }
}
</script>

<template>
  <div>
    <button
      class="btn btn-outline-secondary rounded-0"
      type="button"
      id="button-addon3"
      :disabled="loading"
      @click="aberto = true"
      data-toggle="tooltip"
      data-placement="top"
      title="Importar Azure AD"
    >
      <i class="fa-brands fa-microsoft" aria-hidden="true"></i>
    </button>

    <ModalConfirmacao
      v-model="aberto"
      :loading="loading"
      @confirmar="importAzureAd"
    >
      <template v-slot:header>
        Importar usuários do Azure AD
      </template>
      <template v-slot:body>
        <p class="mb-0">
          A importação consulta o Azure AD e cadastra somente os usuários cujo login ainda não existe na base de dados.
          Usuários já cadastrados não serão alterados.
        </p>
      </template>
    </ModalConfirmacao>
  </div>
</template>
